import { createAction } from "redux-actions";

export const SUBSCRIPTION_LIST = "SUBSCRIPTION_LIST";
export const subscriptionList = createAction(SUBSCRIPTION_LIST);

export const DELETE_SUBSCRIPTION = "DELETE_SUBSCRIPTION";
export const deleteSubscription = createAction(DELETE_SUBSCRIPTION);

export const EXPORT_SUBSCRIPTION = "EXPORT_SUBSCRIPTION";
export const exportSubscription = createAction(EXPORT_SUBSCRIPTION);

export const SMS_SUBSCRIPTION_LIST = "SMS_SUBSCRIPTION_LIST";
export const smsSubscriptionList = createAction(SMS_SUBSCRIPTION_LIST);

export const DELETE_SMS_SUBSCRIPTION = "DELETE_SMS_SUBSCRIPTION";
export const deleteSmsSubscription = createAction(DELETE_SMS_SUBSCRIPTION);

export const EXPORT_SMS_SUBSCRIPTION = "EXPORT_SMS_SUBSCRIPTION";
export const exportSmsSubscription = createAction(EXPORT_SMS_SUBSCRIPTION);
